// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XqKY","clinicsSelect":"styles_clinicsSelect__3MnCx"};